import {
  Container, ContainerOptions,
  Options, OptionBox,
  OptionsHeader, OptionHeader,
  ClearButton, Connections, MouseFollower
} from './styles'
import Xarrow from 'react-xarrows'
import { useEffect, useState } from 'react'
import { orderById, selectedColors, useMousePosition } from '../../utils/mission_helpers'
import { customTheme } from '../../styles/theme'
import { useGame } from '../../contexts'
import ItemOption from './item'
import { t } from '../../adapters/translate/translate'

const ConnectDotsComponent = ({ options, setNewAnswers, connections, setConnections }:any) => {
  const [current, setCurrent] = useState<number>()
  const { game } = useGame()
  const [connectionsColor, setConnectionsColor] = useState<any>({})
  const [itemSelected, setItemSelected] = useState<any>(null)
  const [itemEndSelected, setItemEndSelected] = useState<any>('none')
  const [mouseFollow, setMouseFollow] = useState<boolean>(false)
  const mouseLocalCoordinates = useMousePosition()

  const handleInputClick = (id:any, index:number) => {
    setCurrent(index)
    setItemSelected(id)
    setItemEndSelected('mouseFollower')
    setMouseFollow(true)
  }

  const handleOutputClick = (index:number) => {
    if (current) {
      Object.keys(connections).forEach(el => {
        if (connections[el] === index) {
          delete connections[el]
          setConnections(connections)
        }
      })
      setConnections((prev:any) => ({ ...prev, [`${current}`]: index }))
      setConnectionsColor((prev:any) => ({ ...prev, [`${current}`]: selectedColors() }))
      setCurrent(undefined)
      setItemSelected(null)
      setItemEndSelected('none')
      setMouseFollow(false)
    }
  }

  const optionIsSelected = (item: any) => {
    const connectionsArray = item.type === 'input' ? Object.keys(connections) : Object.values(connections)
    const selected: any = connectionsArray.find((elem: any) => Number(elem) === Number(item.columnId))

    return selected > -1
  }

  const optionIsCurrent = (item: any) => {
    return current === item.columnId
  }

  const optionIsDisabled = (item: any) => {
    return !!current && current !== item.columnId && item.type === 'input'
  }

  const clearSelections = () => {
    Object.keys(connections).forEach(el => {
      delete connections[el]
      setConnections({})
    })
    setCurrent(undefined)
    setItemSelected(null)
    setItemEndSelected('none')
    setMouseFollow(false)
  }

  useEffect(() => {
    setNewAnswers(connections)
  }, [connections])

  const getBgColor = (input:any, type:any) => {
    if (type === 'input') {
      return connectionsColor[input] || '#20B2AA'
    } else {
      const key = getKeyByValue(connections, input) || 0
      return connectionsColor[key] || '#20B2AA'
    }
  }

  const getKeyByValue = (obj:any, value:any) => {
    return Object.keys(obj).find(key => obj[key] === value)
  }

  const handleOutputMouseOver = (id:any) => {
    if (mouseFollow) { setItemEndSelected(`output-${id}`) }
  }

  const handleOutputMouseOut = (id:any) => {
    if (mouseFollow) { setItemEndSelected('mouseFollower') }
  }

  return (
    <Container>
      <OptionsHeader>
        <OptionHeader><span>A</span></OptionHeader>
        <OptionHeader><span>B</span></OptionHeader>
      </OptionsHeader>
      <ContainerOptions id='containerOptions'>
        <MouseFollower id="mouseFollower" style={{ top: mouseLocalCoordinates.y, left: mouseLocalCoordinates.x }} ></MouseFollower>
        <Options>
          {options.sort(orderById).map((item:any, idx:number) => (
            <OptionBox key={idx + 1}>
              <ItemOption
                bg={optionIsSelected(item) ? '#e5e5e5' : '#f5f5f5'}
                border={optionIsSelected(item) || (item.type === 'input' && optionIsCurrent(item)) ? '3.2px' : '2px'}
                borderColor={optionIsSelected(item) ? getBgColor(item.columnId, item.type) : game?.baseColor}
                color={game?.baseColor || customTheme.colors.black}
                disabled={optionIsDisabled(item)}
                handleClick={() => {
                  if (item.type === 'input') {
                    handleInputClick(item.idElement, item.columnId)
                  } else {
                    handleOutputClick(item.columnId)
                  }
                } }
                handleMouseOver={() => {
                  if (item.type !== 'input') { handleOutputMouseOver(item.columnId) }
                } }
                handleMouseOut={() => {
                  if (item.type !== 'input') { handleOutputMouseOut(item.columnId) }
                } }
                id={item.idElement}
                input={item.type === 'input'}
                title={t('Click to select this item')}
              >
                {item.text}
              </ItemOption>
              <Xarrow key={item}
                start={mouseFollow ? itemSelected : 'none'}
                end={itemEndSelected}
                headSize={0}
                startAnchor='right'
                endAnchor='left'
                tailSize={0}
                strokeWidth={2}
                headColor={game?.baseColor }
                lineColor={game?.baseColor}
                dashness={true}
              />
            </OptionBox>
          ))}
        </Options>
      </ContainerOptions>
      <ClearButton onClick={clearSelections}>{t('Undo')}</ClearButton>
      <Connections className='connectionsContainer'>
        {Object.keys(connections).map((item: string) => (
          <Xarrow key={item}
            start={`input-${item}`} // can be react ref
            end={`output-${connections[item]}`} // or an id
            headSize={0}
            startAnchor='right'
            endAnchor='left'
            tailSize={0}
            strokeWidth={2}
            headColor={game?.baseColor || customTheme.colors.green}
            lineColor={getBgColor(item, 'input')}
          />
        ))}

      </Connections>
    </Container>
  )
}

export default ConnectDotsComponent
